import styles from "./Client.module.css";
import { useState, useEffect } from "react";
import { AiOutlineArrowRight } from "react-icons/ai";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { GrAddCircle } from "react-icons/gr";
import { IoCalendarSharp } from "react-icons/io5";
import { PiClockFill } from "react-icons/pi";
import { BsCameraVideo } from "react-icons/bs";
import { MdArrowBackIos } from "react-icons/md";
import { FaEdit } from "react-icons/fa";

import AddTask from "components/AddTask/AddTask";
import Casenotes from "components/CaseNotes/CaseNotes";
import { useHistory, useLocation } from "react-router-dom";
import { getClientCaseNotes, getTherapistClientAssessments, getTherapistClientDetails, getTherapistClientTasks, submitClientNewTasks } from "actions/dataLoad";
import { useUserTokenSelector } from "store/reducers";
import Select from "react-select";


const avatar = {
    female: "https://ucarecdn.com/c22b8f55-8c68-411e-a5c9-8b5b99c08701/femaleEmoji.svg",
    male: "https://ucarecdn.com/52c99efd-cba4-4fe1-93f2-e393088b7a0c/male.svg",
    other: "https://ucarecdn.com/c7bb4c01-2258-428d-b8ce-e2196ee63220/lgbtq.svg",
  };

  const assessmentRangeMap = {
    "No Sign": "",
    "Mild": "Low",
    "Moderate": "Moderate",
    "Severe": "High"
  }


const Client = ({ onClose, clientId, client }) => {
    const { search } = useLocation();
    const query = new URLSearchParams(search);
    const [clientData, setClientData] = useState(client);
    const selectedTab = query.get("tab");
    const date = new Date();
    const symptoms = (clientData.upcomingSession || clientData.pastSession).problemCategory;
    const [editingSymptoms, setEditingSymptoms] = useState(false);
    const [editedSymptoms, setEditedSymptoms] = useState((clientData.upcomingSession || clientData.pastSession).problemCategory?.join(", ") || "");
    const [selectedValue, setSelectedValue] = useState(date.getFullYear());
    const [casenote, setCasenote] = useState([]);
    const [selectedTimeframe, setSelectedTimeframe] = useState('Year');
    const [viewTasks, setViewTasks] = useState(false);
    const [addTask, setAddTask] = useState(false);
    const [tasks, setTasks] = useState([]);
    const [viewCasenote, setViewCasenote] = useState(false);
    const [submitCasenote,setSubmitCasenote] = useState(false);
    const [noteToView, setNoteToView] = useState(null);
    const [sessionForSubmit, setSessionForSubmit] = useState(null);
    const [viewAllNotes, setViewAllNotes] = useState(false);
    const [clientSessions, setClientSessions] = useState([]);
    const [assessmentAnaltyics, setAssessmentAnalytics] = useState([]);
    const token = useUserTokenSelector();
    const history = useHistory();
    
    const years = [2022, 2023, 2024];
    const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const days = ['Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat', 'Sun'];
    const weeks = ["Week 1", "Week 2", "Week 3", "Week 4"];

    const handleTimeFrame = (time) => {
        setSelectedTimeframe(time);
        if (time === "Month") {
            setSelectedValue(months[date.getMonth()]);
        } else if (time === "Year") {
            setSelectedValue(date.getFullYear());
        } else if (time === "Day") {
            setSelectedValue(days[date.getDay()]);
        } else {
            setSelectedValue(weeks[0]);
        }
    }
    const handleIncrement = () => {
        if (selectedTimeframe === 'Year') {
            const currentIndex = years.indexOf(selectedValue);
            setSelectedValue(years[(currentIndex + 1) % 3]);
        } else if (selectedTimeframe === 'Month') {
            const currentIndex = months.indexOf(selectedValue);
            setSelectedValue(months[(currentIndex + 1) % 12]);
        } else if (selectedTimeframe === 'Day') {
            const currentIndex = days.indexOf(selectedValue);
            setSelectedValue(days[(currentIndex + 1) % 7]);
        } else {
            const currentIndex = weeks.indexOf(selectedValue);
            setSelectedValue(weeks[(currentIndex + 1) % 4]);
        }
    };

    const handleDecrement = () => {
        if (selectedTimeframe === 'Year') {
            const currentIndex = years.indexOf(selectedValue);
            setSelectedValue(years[(currentIndex - 1 + years.length) % 3]);
        } else if (selectedTimeframe === 'Month') {
            const currentIndex = months.indexOf(selectedValue);
            setSelectedValue(months[(currentIndex - 1 + months.length) % 12]);
        } else if (selectedTimeframe === 'Day') {
            const currentIndex = days.indexOf(selectedValue);
            setSelectedValue(days[(currentIndex - 1 + days.length) % 7]);
        } else {
            const currentIndex = weeks.indexOf(selectedValue);
            setSelectedValue(weeks[(currentIndex - 1 + days.length) % 4]);
        }
    };
    const handleAddTask = () => {
        setAddTask(true);
    }
    const handleviewtasks = () => {
        setViewTasks(true);
    }
    const handleBack = () => {
        if (viewTasks) {
            setViewTasks(false);
        }
        else if (viewAllNotes) {
            setViewAllNotes(false);
        }
        else {
            onClose();
        }
    }

    const handleTasksSubmit = async ({  tasks, day, month, year }) => {
        try {
            const res = await submitClientNewTasks(clientId, tasks, new Date().toISOString().slice(0, 10), token);
            setTasks(res.data.tasks)
            setAddTask(false);
        }
        catch (error) {
            console.error("Error submitting tasks: "+ error.message);
        }
    }

    const handleEditSymptoms = () => {
        setEditingSymptoms(true);
    };
    const handleSaveSymptoms = () => {
        const updatedSymptoms = editedSymptoms.split(", ");
        const updatedClient = { ...clientData, symptoms: updatedSymptoms };
        setClientData(updatedClient);
        setEditingSymptoms(false);
    };
    const handleChange = (e) => {
        setEditedSymptoms(e.target.value);
    };

    const handleViewCasenotes = () => {
        setViewAllNotes(true);
    }

    const handleCasenote = (type, data) => {
        if (type === "submit") {
            setSessionForSubmit(data); // 'data' is the session object
            setSubmitCasenote(true);
        } else if (type === "view") {
            setNoteToView(data); // 'data' is the note object to view
            setViewCasenote(true);
        }
    }

    const handleCasenoteBack = (newlySubmittedNote) => {
        setViewCasenote(false);
        setSubmitCasenote(false);
        setNoteToView(null);
        setSessionForSubmit(null);

        if (newlySubmittedNote && typeof newlySubmittedNote === 'object') {
            // Add the newly submitted note to the local state
            setCasenote(prevNotes => [newlySubmittedNote, ...prevNotes].sort((a, b) => new Date(b.CaseNotesUploadTimestamp || 0) - new Date(a.CaseNotesUploadTimestamp || 0)));
        } else if (submitCasenote) { 
            // Fallback: If a note was being submitted but not passed back, refetch.
            // This might happen if Casenotes.js doesn't pass it back or on an error before that.
            fetchClientCaseNotes(clientId, token);
        }
    }

    const fetchClientDetails = async (clientId, token) => {
        try {
            const res = await getTherapistClientDetails({ clientID: clientId }, token);
            const { upcomingBookings, completedBookings, assessmentData } = res.data.data;
            setClientSessions([...upcomingBookings.data, ...completedBookings.data]);
            setAssessmentAnalytics(assessmentData);
        }
        catch (error) {
            console.error("Error fetching client data: "+ error.message);
        }
    };

    const fetchClientCaseNotes = async (clientId, token) => {
        try {
            const res = await getClientCaseNotes(clientId, token);
            setCasenote(res.data.list);
            if (selectedTab === "casenotes") {
                setViewTasks(true);
            }
        }
        catch (error) {
            console.error("Error fetching caseNotes : "+ error.message);
        }
    }

    const fetchClientTasks = async (clientId, token) => {
        try {
            const res = await getTherapistClientTasks(clientId, token);
            setTasks(res.data.tasks);
            if (selectedTab === "tasks") {
                setViewTasks(true);
            }
        }
        catch (error) {
            console.error("Error fetching client tasks: "+ error.message);
        }
    }

    useEffect (() => {
        fetchClientDetails(clientId, token);
        fetchClientCaseNotes(clientId, token);
        fetchClientTasks(clientId, token);
    }, []);


    const formatDate = (timestamp) => {
        if (!timestamp) {
            return "N/A"; // Or any placeholder for missing dates
        }
        const dateObj = new Date(timestamp);
        if (isNaN(dateObj.getTime())) { // Check if the date is invalid
            return "Invalid Date"; // Or your preferred placeholder
        }
        return dateObj.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    };

    return (
        <>
        {
            viewCasenote && noteToView ? (
                <Casenotes client={clientData} view={true} id={noteToView} onCasenoteBack={handleCasenoteBack} caseNote={casenote}/>
            ) : submitCasenote && sessionForSubmit ? (
                <Casenotes client={clientData} view={false} id={sessionForSubmit} onCasenoteBack={handleCasenoteBack} caseNote={casenote} />
            )
                : <>
                    <div className={styles['client-top']}>
                        <div className={styles['client-close']} onClick={handleBack}>
                            <MdArrowBackIos size={18} style={{ marginLeft: "8px" }} />
                        </div>
                        <div className={styles['client-profile']}>
                            <div className={styles['CP-pic-bg']}>
                            <img src={clientData.avatar_url || avatar[clientData.gender || "female"]} alt="user-avatar"/>
                            </div>
                            <div className={styles['profile-rt']}>
                                <div className={styles['profile-rtt']}>
                                    <div>
                                        <p className={styles['CP-data-heading']} style={{fontSize:'20px'}}>{clientData.name}</p>
                                        <p className={styles['CP-data-heading']}>Age:<p className={styles['CP-data-details']}>{clientData.age}{" "}yrs</p></p>
                                    </div>
                                    <div className={styles['CP-msg-bg']} onClick={() => history.push(`/dashboard/therapist/chats/${(clientData.upcomingSession || clientData.pastSession)?.userID}`)}>
                                        <img src="https://ucarecdn.com/83c14859-a37e-4a28-9665-f3b2e819b5be/chatIcon.svg" alt="msg" className={styles['CP-msg-icon']}/>
                                    </div>
                                </div>
                                <div className={`${styles['profile-sum']} ${(viewAllNotes || viewTasks) ? styles.hide : ''}`}>
                                    <p className={styles['CP-row']}>
                                        <span className={styles['CP-data-heading']}>Problems: &nbsp;</span> 
                                        {symptoms?.length === 0 ? (
                                            <span>-</span>
                                        ) : !editingSymptoms && (
                                            symptoms?.map((symptom, index) => (
                                                <span key={index}>{symptom}{symptoms?.length - 1 > index && ", "}</span>
                                            ))
                                        )}
                                        {/* {editingSymptoms ? (
                                            <>
                                                <input type="text" value={editedSymptoms} onChange={handleChange} className={styles['sedit']} />
                                                <button onClick={handleSaveSymptoms} className={styles['sedit-btn']}>Save</button>
                                            </>
                                        ) : (
                                            <button className={styles['edit-sbtn']}>
                                                <FaEdit onClick={handleEditSymptoms} />
                                            </button>
                                        )} */}
                                    </p>
                                    <p className={styles['CP-row']}>
                                        <span className={styles['CP-data-heading']}>Last Session Date:</span> <p className={styles['CP-data-details']}>{new Date((clientData.pastSession)?.sessionDate || (clientData.upcomingSession)?.sessionDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' }).replace(/ /g, ' ').replace(/ /, ', ')}</p>
                                    </p>
                                    <p className={styles['CP-row']}>
                                        <span className={styles['CP-data-heading']}>Problem description:</span><p className={styles['CP-data-details']}>{(clientData.upcomingSession || clientData.pastSession).problemDescription}</p>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        !viewTasks && !viewAllNotes && <div className={styles['client-mid']}>
                            <div className={styles['casenotes']}>
                                <div className={styles['casenotes-top']}>
                                    <p className={styles['client-heading']}>Case Notes</p>
                                    <p className={`${styles.viewall} ${styles.note}`} onClick={handleViewCasenotes}>View All</p>
                                </div>
                                <div className={styles['casenotes-div']}>
                                    {
                                        casenote.length > 0 ? casenote.slice(0,2).map((note, index) => ( // Show only first 2 notes
                                            <div className={styles['casenote']} key={note._id || index}>
                                                <div className={styles['casenote-txt']}>
                                                    <p className={styles['CP-data-heading']}>{new Date(note.CaseNotesUploadTimestamp).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</p>
                                                    <p className={styles['CP-subdata-details']}>{(note.goals || "No goal specified").slice(0, 10)}{"..."}</p>
                                                </div>
                                                <div className={styles['casenote-btn']} onClick={() => handleCasenote("view", note)}>
                                                    <AiOutlineArrowRight size={26} />
                                                </div>
                                            </div>
                                        ))
                                        : (
                                            <p>No case notes yet</p>
                                        )
                                    }
                                </div>
                            </div>

                            <div className={styles['client-symptom']}>
                                <p className={styles['client-heading']}>Symptoms</p>
                                <div className={styles['symptom-div']}>
                                    <div className={styles['symptom-filters']}>
                                        <div className={styles['timeframe']}>
                                            <input type="button" value="Day" onClick={() => handleTimeFrame("Day")} className={`${selectedTimeframe === "Day" && styles.active}`}/>
                                            <input type="button" value="Week" onClick={() => handleTimeFrame("Week")} className={`${selectedTimeframe === "Week" && styles.active}`} />
                                            <input type="button" value="Month" onClick={() => handleTimeFrame("Month")} className={`${selectedTimeframe === "Month" && styles.active}`} />
                                            <input type="button" value="Year" onClick={() => handleTimeFrame("Year")} className={`${selectedTimeframe === "Year" && styles.active}`} />
                                        </div>
                                        <div className={styles['value']}>
                                            <IoIosArrowBack onClick={handleDecrement} className={styles['dec-icon']}/>
                                            <p>{selectedValue}</p>
                                            <IoIosArrowForward onClick={handleIncrement} className={styles['inc-icon']}/>
                                        </div>
                                    </div>
                                    <div className={styles['client-symptoms']}>
                                        {assessmentAnaltyics?.map((symptom, index) => (
                                            <div className={styles['symptom']} key={index}>
                                                <div className={styles['symptom-name']}>
                                                    <p>{symptom.quizName}</p>
                                                </div>
                                                <div className={styles['level-div']}>
                                                    <p>{symptom.identifier}</p>
                                                    <div className={styles['symptom-level']}><div className={styles[assessmentRangeMap[symptom?.identifier || "No Sign"]]}></div></div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        viewAllNotes && <div className={styles['casenotes']}>
                            <div className={styles['casenotes-top']}>
                                <p className={styles['client-heading']}>Case Notes</p>
                                {/* <p className={`${!viewAllNotes ? `${styles.viewall} ${styles.note}` : styles.hide}`} onClick={handleViewCasenotes}>View All</p> */}
                            </div>
                            <div className={`${styles['casenotes-div']} ${styles['all']}`}>
                                {
                                    casenote.map((note, index) => (
                                        <div className={styles['casenote']} key={note._id || index}>
                                            <div className={styles['casenote-txt']}>
                                                <p className={styles['casenote-txtd']}>{formatDate(note.CaseNotesUploadTimestamp)}</p>
                                                <p>{(note.goals || "No goal specified").slice(0, 10)}{"..."}</p>
                                            </div>
                                            <div className={styles['casenote-btn']} onClick={() => handleCasenote("view", note)}>
                                                <AiOutlineArrowRight size={26} />
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    }
                    {
                        !viewAllNotes && <div className={styles['client-mid']}>
                            <div className={`${styles['client-tasks']} ${viewTasks ? styles.all : ''}`}>
                                <div className={styles['tasks-top']}>
                                    <p className={styles['client-heading']}>Tasks</p>
                                    {!viewTasks && tasks.length > 0 && <p onClick={handleviewtasks} className={styles['viewall']}>View All</p>}
                                </div>
                                <div className={styles['tasks']}>
                                {
                                    (() => {
                                        const displayItems = [];
                                        const addTaskButton = (keySuffix = "") => (
                                            <div className={styles['task-div']} onClick={handleAddTask} key={`add-task-${keySuffix}`}>
                                                <div className={styles['task-top']}>
                                                    <p className={styles['CP-AddTask-Card-data']}>Add Task</p>
                                                </div>
                                                <div className={styles['add-task']}><GrAddCircle size={30} color="#49AF7C" /></div>
                                            </div>
                                        );

                                        const taskToCard = (task, index) => (
                                            <div className={styles['task-div']} key={task._id || `task-${index}`}>
                                                <div className={styles['task-date']}><p>{new Date(task.date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</p></div>
                                                <p>{task.task}</p>
                                            </div>
                                        );

                                        if (!viewTasks) {
                                            if (tasks.length === 0) {
                                                displayItems.push(addTaskButton("empty"));
                                            } else if (tasks.length === 1) {
                                                displayItems.push(taskToCard(tasks[0], 0));
                                                displayItems.push(addTaskButton("single"));
                                            } else if (tasks.length === 2) {
                                                displayItems.push(taskToCard(tasks[0], 0));
                                                displayItems.push(taskToCard(tasks[1], 1));
                                                displayItems.push(addTaskButton("double")); // Add Task as the third card
                                            } else if (tasks.length === 3) {
                                                tasks.slice(0, 3).forEach((task, index) => displayItems.push(taskToCard(task, index)));
                                                // No "View All" yet. Add Task button is separate or handled by global add.
                                            } else { // tasks.length > 3
                                                tasks.slice(0, 2).forEach((task, index) => displayItems.push(taskToCard(task, index))); // Show 2 most recent
                                                displayItems.push(
                                                    <div className={styles['task-div']} style={{ justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={handleviewtasks} key="view-all">
                                                        <p className={styles.viewall}>View All</p>
                                                    </div>
                                                );
                                            }
                                        } else { // viewTasks is true
                                            tasks.forEach((task, index) => displayItems.push(taskToCard(task, index)));
                                            displayItems.push(addTaskButton("all")); // Always show "Add Task" when viewing all
                                        }
                                        return displayItems;
                                    })()
                                }
                                </div>
                            </div>
                            {
                                !viewTasks && !viewAllNotes && <div className={styles['client-sessions']}>
                                    <p className={styles['client-heading']}>Sessions</p>
                                    <div className={styles['sessions']}>
                                        {
                                            clientSessions.filter(item => item.isCancel === false).map((session, index) => {
                                                const date = new Date();
                                                const startTime = new Date(session.sessionTime.start)
                                                let completed = true;
                                                if (startTime > date) {
                                                    completed = false;
                                                }

                                                const fifteenMinutes = 15 * 60 * 1000; // 15 minutes in milliseconds
                                                const timeDifferenceToStart = startTime.getTime() - date.getTime();
                                                const sessionEndTime = new Date(session.sessionTime.end);
                                                
                                                const isJoinable = 
                                                    !completed && // Session is upcoming
                                                    timeDifferenceToStart <= fifteenMinutes && // Starts within 15 mins
                                                    date.getTime() < sessionEndTime.getTime(); // Current time is before session end time

                                                return (
                                                    <div className={`${styles.session} ${!completed ? styles.current : ''}`} key={session._id || index}>
                                                        <div className={styles['session-ele']}>
                                                            <IoCalendarSharp color={"#49AF7C"} size={20}/>
                                                            <p>{new Date(session.sessionDate).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })}</p>
                                                        </div>
                                                        <div className={styles['line']}></div>
                                                        <div className={styles['session-ele']}>
                                                            <PiClockFill color={"#49AF7C"} size={20}/>
                                                            <p>{new Date(session.sessionTime.start).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }).toLowerCase()} - {new Date(session.sessionTime.end).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }).toLowerCase()}</p>
                                                        </div>
                                                        {
                                                            !completed ? <div className={`${styles['session-btn']} ${styles['current']} ${!isJoinable ? styles.disabled : ''}`}>
                                                                <a href={isJoinable ? session.link : undefined}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    onClick={(e) => {
                                                                        if (!isJoinable) {
                                                                            e.preventDefault(); // Prevent navigation if not joinable
                                                                        }
                                                                    }}
                                                                    >
                                                                    <div className={styles['join-div']}>
                                                                        <p>Join Now</p>
                                                                        <BsCameraVideo size={20} color="white" />
                                                                    </div>
                                                                </a>
                                                            </div> :
                                                                <div className={styles['session-btn']}>
                                                                    {casenote.find(cn => cn.SessionID === session._id) ? 
                                                                        <p onClick={() => handleCasenote("view", casenote.find(cn => cn.SessionID === session._id))}>View Case Notes</p> : 
                                                                        <p onClick={() => handleCasenote("submit", session)}>Submit Case Note</p>}
                                                                </div>
                                                        }
                                                    </div>
                                                );

                                            })
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    }

                    {
                        addTask &&
                        <AddTask
                            onClose={() => setAddTask(false)}
                            handleTasksSubmit={handleTasksSubmit}
                        />
                    }
                </>
        }
    </>
    );
};

export default Client;
